﻿import { WorkItemInfo } from 'runtime/data/workiteminfo';

export class WorkItemNotAvailableForClaim {
    reason: string; //ClaimFailureReason;
    workItemInfo: WorkItemInfo;
}

export class ClaimFailureReason {
    static claimedByAnotherUser = 'claimedByAnotherUser';
    static claimedByCurrentUser = 'claimedByCurrentUser';
    static stepCompleted = 'stepCompleted';
    static unknown = 'unknown';
}